import React, { useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import BookingListComponent from "../../components/Booking/BookingList";



export default function BookingList() {
    useEffect(() => {
        window.scrollTo(0, 0);
    })

    return (
        <div
            style={{ flex: 1 }}
            onClick={() => {
                document.body.classList.remove("offcanvas-active");
            }}
        >
            <div>
                <div className="container-fluid">
                    <PageHeader
                        HeaderText="Bookings"
                        Breadcrumb={[
                            { name: "Bookings", navigate: "" },
                        ]}
                    />
                    <div className="row clearfix">
                        <BookingListComponent />
                    </div>
                </div>
            </div>
        </div>
    );
}
